import React from 'react';
import { IconButton, Switch, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeMode } from './AppThemeProvider';

interface ThemeToggleProps {
  variant?: 'icon' | 'switch';
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ variant = 'icon' }) => {
  const { mode, toggleColorMode } = useThemeMode();
  // Removed unused variable: const theme = useTheme();

  if (variant === 'switch') {
    return (
      <Tooltip title={mode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}>
        <Switch
          checked={mode === 'dark'}
          onChange={toggleColorMode}
          color="primary"
          inputProps={{ 'aria-label': 'toggle theme' }}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={mode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}>
      <IconButton onClick={toggleColorMode} color="inherit" aria-label="toggle theme">
        {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
